module.exports = __webpack_public_path__ + "img/31.6c968cc0.jpg";